import { Component } from '@angular/core';
import { IonSpinner } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-spinner-loading',
  templateUrl: './spinner-loading.component.html',
  styleUrls: ['./spinner-loading.component.scss'],
  imports: [IonSpinner, TranslateModule],
})
export class SpinnerLoadingComponent {
  // constructor() {}
}
